module.exports = __webpack_public_path__ + "static/media/mealplanner-thumbnail.aa1f3b6e.png";